import React, { useState } from 'react';
import { Pressable } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button } from 'app/src/elements/buttons';
import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';
import { Text } from 'app/src/styles';
import { titlecase } from 'app/src/utils/formatting';

import { CREATE_MAKE } from './queries';

export const FIELDS = {
  code: {
    rules: {
      required: true,
      maxLength: { value: 6, message: 'Maximum length is 6 characters' },
    },
  },
  label: { rules: { required: true, }, },
  notes: { },
  primary: {
    label: 'Primary label for this code?',
    type: 'boolean',
  },
};

const NewMake = ({ setShow, refetch, replace, label }) => {
  const [formStatus, setFormStatus] = useState();

  const resource =
    replace ? { code: replace.code, primary: replace.primary } : { label };

  const {
    control, handleSubmit, setValue, watch, formState: { errors }
  } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource })
  });

  const [createMake] = useMutation(CREATE_MAKE, {
    onCompleted: () => {
      refetch();
      setShow(false);
    }
  });

  const onSubmit = input => {
    setFormStatus('submitting');

    createMake({
      variables: {
        ...prepareInput(input, FIELDS),
        replaceId: replace?.id,
      }
    });
  };

  const titlecaseLabel = () => {
    setValue('label', titlecase(watch('label')));
  };

  const fields = { ...FIELDS };
  fields.label = {
    ...fields.label,
    hint: (
      <Pressable onPress={titlecaseLabel}>
        <Text>⤇ Title case label</Text>
      </Pressable>
    )
  };

  return (
    <Modal title="Create Make" setShow={setShow}>
      <Fields fields={fields} control={control} errors={errors} />

      <Button
        label="Save"
        onPress={handleSubmit(onSubmit)}
        disabled={'submitting' === formStatus}
        wide
      />
    </Modal>
  );
};

export default NewMake;
